import getEnv from "../utils/env";

export const VIASAT_AD_ENDPOINT= getEnv("VUE_APP_VIASAT_AD_ENDPOINT");

export function initializeAdvertisements(): void {
    // const router = useRouter();
}